<p-card header="Submission Details">
    <p-panel header="Injured Worker Info"  styleClass="mb-4">
        <div class="flex flex-auto flex-column">
            <div class="m-2">
                {{ submission?.patientFirstName }} {{ submission?.patientLastName }} {{submission?.patientDateOfBirth | date: 'shortDate'}}
            </div>
            <div *ngIf="submission?.addressLine1" class="m-2 mb-0">
                {{submission?.addressLine1}}
            </div>
            <div *ngIf="submission?.addressLine2" class="mr-2 ml-2">
                {{submission?.addressLine2}}
            </div>
            <div *ngIf="submission?.addressCity && submission?.addressState && submission?.addressZip"  class="m-2 mt-0">
                {{submission?.addressCity}}, {{submission?.addressState}} {{submission?.addressZip}}
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Phone: 
                </div>
                <div class="col-6">
                    {{submission?.patientPhone}}
                </div>
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Email: 
                </div>
                <div class="col-6">
                    {{submission?.patientEmail}}
                </div>
            </div>
        </div>
    </p-panel>
    <p-panel header="Claim Info" styleClass="mb-4">
        <div class="flex flex-auto flex-column">
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Claim Number:
                </div>
                <div class="col-6">
                    {{submission?.claimNumber}} 
                </div>
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Date Of Injury: 
                </div>
                <div class="col-6">
                    {{submission?.dateOfInjury | date: 'shortDate'}} 
                </div>
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Body Part: 
                </div>
                <div class="col-6">
                    {{submission?.bodyPart}} Side: {{submission?.bodySide}}
                </div>
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Jurisdiction: 
                </div>
                <div class="col-6">
                    {{submission?.jurisdiction}}
                </div>
            </div>
            <div class="m-2  flex grid">
                <div class="col-12 justify-content-start">
                    Accident Description:
                </div>
                <div class="col-12 ml-3">
                    {{submission?.accidentDescription}}
                </div>
                <div class="col-6 justify-content-start">
                    Injury Description:
                </div>
                <div class="col-12 ml-3">
                    {{submission?.injuryDescription}}
                </div>
            </div>
        </div>
    </p-panel>
    <p-panel header="Procedure Info" styleClass="mb-4">
        <div class="flex flex-auto flex-column">
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Procedure Type: 
                </div>
                <div class="col-6">
                    {{submission?.procedureType}}
                </div>
            </div>
            <div class="flex flex-column m-2"> 
                <div *ngFor="let procedure of submission?.procedures" class="flex flex-row justify-content-between">
                    <div class="flex flex-auto">
                        {{procedure.procedureCode}}
                    </div>
                </div>
            </div>
            <div *ngIf="submission?.referringProvider" class="m-2">
                Ordering Provider: {{submission?.referringProvider}} {{submission?.referringProviderLocation}}
            </div>
            <div *ngIf="submission?.servicingProvider" class="m-2">
                Servicing Provider: {{submission?.servicingProvider}}
            </div>
        </div>
    </p-panel>
    <p-panel header="Payer Info" styleClass="mb-4">
        <div class="flex flex-auto flex-column">
            <div class="m-2 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Adjuster:
                </div>
                <div class="col-6">
                    {{submission?.adjusterFirstName}} {{submission?.adjusterLastName}}
                </div>
            </div>
            <div class="m-2 mt-0 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Phone: 
                </div>
                <div class="col-6">
                    {{submission?.adjusterPhone}}
                </div>    
            </div>
            <div *ngIf="submission?.adjusterEmail" class="m-2 mt-0 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Email:                 
                </div>
                <div class="col-6">
                    {{submission?.adjusterEmail}}
                </div>
            </div>
            <div class="m-2 mt-0 flex grid">
                <div class="col-6 justify-content-end">
                    Payer:                
                 </div>
                <div class="col-6">
                    {{submission?.payerName}}
                </div>
            </div>
        </div>
    </p-panel>
    <p-panel header="Submitter Info" styleClass="mb-4">
        <div class="flex flex-auto flex-column">
            <div class="m-2 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Submitter:                
                 </div>
                <div class="col-6">
                    {{submission?.submittedByFirstName}} {{submission?.submittedByLastName}}
                </div>
            </div>
            <div class="m-2 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Job Function:                
                 </div>
                <div class="col-6">
                    {{submission?.submitterJobFunction}}
                </div>
            </div>
            <div class="m-2 mt-0 mb-0 flex grid">
                <div class="col-6 justify-content-end">
                    Phone:                
                 </div>
                <div class="col-6">
                    {{submission?.submitterPhone}}
                </div>
            </div>
            <div  class="m-2 mt-0 flex grid">
                <div class="col-6 justify-content-end">
                    Email:                
                 </div>
                <div class="col-6">
                    {{submission?.submitterEmail}}
                </div>
            </div>
            <div class="m-2 flex grid">
                <div class="col-6 justify-content-end">
                    Special Instructions:                
                 </div>
                <div class="col-6">
                    {{submission?.specialInstructions}}
                </div>
            </div>
        </div>
    </p-panel>
</p-card>
